<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Careers"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="$router.push({ name: 'careers.new' })" class="btn btn--primary btn--primary--sml" v-if="checkPermission('careers', 'create')">New Career</app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('careers', 'view')">
                <strong class="block mb-4">Publishable:</strong>
                <app-table v-if="careers.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published At
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(c, i) in careers" :key="i">
                            <app-table-cell>
                                {{ c.title }}

                                <router-link :to="{ name: 'careers.drafts.home', params: { id: c.id } }" v-if="c.drafts.length > 0 && checkPermission('careers', 'publishable')" class="mt-2 text-grey block text-xs">
                                    <span v-html="c.drafts.length" class="font-bold"></span> awaiting draft(s)
                                </router-link>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <router-link :to="{ name: 'careers.new.child', params: { id: c.id } }" v-if="c.locale.flag != locale.flag && !isTranslated(c, locale)">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </router-link>
                                    <router-link v-else :to="{ name: 'careers.edit', params: { id: getId(c, locale) } }">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </router-link>
                                </div>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <app-icon :icon="c.published ? 'check-circle' : 'times-circle'" :class="{'text-green': c.published, 'text-red': !c.published, 'text-lg': true}" />
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                {{ moment(c.published_at).format('D MMM YY') }}
                                <span class="text-xs block mt-1 text-grey">({{ moment(c.published_at).fromNow() }})</span>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'careers.edit', params: { id: c.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('careers', 'edit') && c.children.length < 1">
                                    <app-icon icon="edit" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = c.id" v-if="checkPermission('careers', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <app-pagination-links
                    :response="response"
                    :resources="careers"
                    @next="selectNextPage"
                    @previous="selectPreviousPage"
                />
            </app-box>

            <app-box :loading="loading" :initial="loading" class="mt-8" v-if="drafts.length > 0 && checkPermission('careers', 'view') && checkPermission('careers', 'publishable')">
                <strong class="block mb-4">Drafted:</strong>
                <app-table>
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(d, i) in drafts" :key="i">
                            <app-table-cell>
                                {{ d.title }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <span v-if="d.locale.flag != locale.flag">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </span>
                                    <span v-else>
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </span>
                                </div>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'careers.view', params: { id: d.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('careers', 'edit')">
                                    <app-icon icon="eye" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = d.id" v-if="checkPermission('careers', 'delete')"/>
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a career. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'offers.home',

        data: () => ({
            loading: true,
            careers: [],
            drafts: [],
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal
        },

        mounted() {
            this.getCareers()
                .then(response => {
                    return this.getDraftCareers();
                })
                .then(response => {
                    this.loading = false;
                });
        },

        methods: {
            getCareers() {
                let params = {};

                if (this.$route.query.page) {
                    params.page = this.$route.query.page;
                }

                return Api.request('get', `careers?${this.prepareGetQueryString(params)}`)
                    .then(({ data }) => {
                        this.careers = data.careers;
                        this.response = data;
                    });
            },
            getDraftCareers() {
                let params = {};

                return Api.request('get', `careers/drafts`)
                    .then(({ data }) => {
                        this.drafts = data.careers;
                    });
            },
            remove() {
                this.confirmModalOpened = false;
                this.loading = true;

                this.deleteCareers( this.confirmModalId ).then(response => {
                        return this.getCareers();
                    }).then(response => {
                        return this.getDraftCareers();
                    }).then(response => {
                        this.loading = false;
                        this.confirmModalId = false;
                    });
            },
            deleteCareers(id) {
                return Api.request('get', `careers/delete/${id}`);
            },
            isTranslated(offer, locale) {
                let translated = false;

                if (offer.children.length > 0 && offer.locale.flag != locale.flag) {
                    offer.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            translated = true;
                        }
                    });
                }

                return translated;
            },
            getId(offer, locale) {
                let id = offer.id;

                if (offer.children.length > 0 && offer.locale.flag != locale.flag) {
                    offer.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            id = child.id;
                        }
                    });
                }

                return id;
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/careers/Home.vue